export default {
  state: {
    dataList: [
      `<style>
        .c_t_1 > div.row {
          display: flex;
          flex-direction: row;
          padding: 60px 0px;
        }
        .c_t_1 > div:nth-of-type(1) {
          padding-left: 30px;
          padding-right: 30px;
        }
        .c_t_1 > div:nth-of-type(1) .img_box {
          flex: 0 0 auto;
          width: 519px;
          height: 373px;
          border: 3px solid #ffffff;
          background: linear-gradient(0deg, #ffffff 0%, #f3f5f8 100%);
          box-shadow: 0px 6px 24px 0px #e7edf8;
          border-radius: 2px;
          box-sizing: border-box;
          overflow: visible;
        }
        .c_t_1 > div:nth-of-type(1) .img_box img {
          width: 492px;
          height: 345px;
          margin: 11px 0 0 11px;
          object-fit: cover;
        }
        .c_t_1 > div:nth-of-type(1) .info {
          flex: 1 1 0;
          margin-left: 45px;
        }
        .c_t_1 > div:nth-of-type(1) .info > div.title {
          margin-top: 10px;
          position: relative;
          padding-left: 1.3em;
          font-size: 16px;
          color: #333333;
        }
        .c_t_1 > div:nth-of-type(1) .info > div.title::before {
          content: "";
          display: block;
          position: absolute;
          left: 0px;
          top: 6px;
          width: 1em;
          height: 1em;
          background: url("img/about-us/organization_module/title_icon.png") no-repeat center center /
            contain;
        }
        .c_t_1 > div:nth-of-type(1) .info > div.text {
          margin-top: 10px;
          font-size: 14px;
          font-family: SourceHanSansCN-Light;
          font-weight: bold;
          color: #6e7b91;
          line-height: 26px;
        }
        .c_t_1 > div:nth-of-type(1) .info > div:nth-of-type(1) {
          margin-top: 10px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          line-height: 26px;
          position: relative;
          z-index: 1;
        }
        .c_t_1 > div:nth-of-type(1) .info > div:nth-of-type(1)::after {
          content: "";
          display: inline-block;
          position: absolute;
          left: 0px;
          bottom: 0px;
          width: 400px;
          height: 11px;
          background-color: #cae3ff;
          z-index: -1;
        }
        .c_t_1 > div:nth-of-type(1) .info > div:nth-of-type(2) {
          margin-bottom: 20px;
        }
        .c_t_1 > div:nth-of-type(2) {
          display: block;
        }
        .c_t_1 > div:nth-of-type(2) > div {
          text-align: center;
        }
        .c_t_1 > div:nth-of-type(2) > div.text {
          margin-top: 10px;
          font-size: 14px;
          font-family: SourceHanSansCN-Light;
          font-weight: bold;
          color: #6e7b91;
          line-height: 26px;
          text-align: center;
        }
        .c_t_1 > div:nth-of-type(2) > div:nth-of-type(1) {
          display: block;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          line-height: 26px;
          position: relative;
          z-index: 1;
        }
        .c_t_1 > div:nth-of-type(2) > div:nth-of-type(1)::after {
          content: "";
          display: inline-block;
          position: absolute;
          left: calc(50% - 55px);
          bottom: 0px;
          width: 110px;
          height: 11px;
          background-color: #cae3ff;
          z-index: -1;
        }
        .c_t_1 > div:nth-of-type(2) img {
          margin: 20px auto 0;
          display: block;
        }
        .c_t_1 > div:nth-of-type(3) {
          width: 1044px;
          font-size: 18px;
          color: #333333;
          line-height: 31px;
          margin: 50px auto 0;
        }
        .c_t_1 > div:nth-of-type(4) {
          text-align: center;
          margin-top: 30px;
        }
        .c_t_1 > div:nth-of-type(5) {
          margin-top: 67px;
          box-sizing: border-box;
          height: 440px;
          padding: 0 100px;
          background: url("img/about-us/organization_module/08.png") no-repeat center center / 100% 100%;
          color: white;
        }
        .c_t_1 > div:nth-of-type(5) > div:nth-of-type(1) {
          font-size: 22px;
          padding-top: 50px;
          text-align: center;
        }
        .c_t_1 > div:nth-of-type(5) > div:nth-of-type(2) {
          margin: 22px auto 0;
          width: 820px;
          font-size: 14px;
          font-family: SourceHanSansCN-Light;
          color: #d8e5ff;
          line-height: 26px;
          text-align: center;
        }
        .c_t_1 > div:nth-of-type(5) > div:nth-of-type(3) {
          margin-top: 32px;
          display: flex;
          justify-content: space-between;
        }
        .c_t_1 > div:nth-of-type(5) > div:nth-of-type(3) img {
          width: 316px;
          height: 194px;
          object-fit: cover;
        }
        .c_t_1 > div:nth-of-type(6) {
          padding: 0 100px;
          height: 380px;
          background: url("img/about-us/organization_module/09.png") no-repeat center center / 100% 100%;
          overflow: hidden;
        }
        .c_t_1 > div:nth-of-type(6) > div:nth-of-type(1) {
          margin: 40px auto 0;
          width: 820px;
          font-size: 14px;
          font-family: SourceHanSansCN-Light;
          font-weight: bold;
          line-height: 26px;
          text-align: center;
        }
        .c_t_1 > div:nth-of-type(6) > div:nth-of-type(2) {
          margin-top: 32px;
          display: flex;
          justify-content: space-between;
        }
        .c_t_1 > div:nth-of-type(6) > div:nth-of-type(2) img {
          width: 316px;
          height: 194px;
          object-fit: cover;
        }
      </style>
      <div class="c_t_1">
        <div class="row">
          <div class="img_box">
            <img src="img/about-us/organization_module/a.jpg" />
          </div>
          <div class="info">
            <div>&nbsp;工业互联网数字化转型促进中心(省级)概况&emsp;</div>
            <div class="text">
              晋中开发区工业互联网数字化转型促进中心被省发改委正式认定为第一批省级数字化转型促进中心，这为综改区晋中开发区在全市乃至全省数字化转型中打开了新通道，为打造数字产业集聚地开辟了新路径。
            </div>
            <div class="title">中心类型</div>
            <div class="text">区域型数字化转型促进中心</div>
            <div class="title">功能定位</div>
            <div class="text">
              立足晋中，面向山西，为企业提供测试验证、转型咨询、诊断评估、需求撮合、应用示范、创新孵化、交流推广等公共服务。
            </div>
            <div class="title">创建基础</div>
            <div class="text">
              根据山西省发改委《关于创建第一批山西省省级数字化转型促进中心的通知》和《关于组织申报第一批山西省省级数字化转型促进中心的通知》要求创建。
            </div>
          </div>
        </div>
        <div>
          <div>团队架构</div>
          <div class="text">
            促进中心团队由开发区相关部门、国家级科研院所、国企技术人员、高校教授、行业专家等114人组成。
          </div>
          <img src="img/about-us/organization_module/_01.png" />
        </div>
        <div>
          政府、企业、共建单位携手打造数字化转型新生态，组建评审测评中心、数字化项目部、转型促进服务部、培训实训中心、综合服务保障部，两中心三部门，助推我区打造良好的数字化生态体系。
        </div>
        <div>
          <img src="img/about-us/organization_module/_02.png" />
        </div>
        <div>
          <div>硬件优势</div>
          <div>
            促进中心基础共性软硬件设备俱全、应用广泛，可通过3D投影、全息影片、数据大屏、库卡机器人、模拟产线、互动沙盘等多种形式，满足开展数字化转型演示示范、推广应用和创新孵化的全部要求。正在进行二期改造，增加人才实训应用场景。
          </div>
          <div>
            <img src="img/about-us/organization_module/10.png" />
            <img src="img/about-us/organization_module/11.png" />
            <img src="img/about-us/organization_module/12.png" />
          </div>
        </div>
        <div>
          <div>
            促进中心基础共性软硬件设备俱全、应用广泛，可通过3D投影、全息影片、数据大屏、库卡机器人、模拟产线、互动沙盘等多种形式，满足开展数字化转型演示示范、推广应用和创新孵化的全部要求。正在进行二期改造，增加人才实训应用场景。
          </div>
          <div>
            <img src="img/about-us/organization_module/13.png" />
            <img src="img/about-us/organization_module/14.png" />
            <img src="img/about-us/organization_module/15.png" />
          </div>
        </div>
      </div>`,
      `<div style="padding: 60px 60px; font-size: 18px; color: #333333; line-height: 31px;">
        <p style="text-indent: 2em;">
        <h1 style="text-align: center;font-weight: bold;">晋中开发区信息网络发展有限公司</h1>
        <br />
      </p>
      <p style="text-indent: 2em;text-align: center">
        <img src="img/about-us/organization_module/06.png" alt="" data-href="" style="margin: 0 auto">
      </p>
      <br />
      <p style="text-indent: 2em;">
        <span style="color: rgb(68, 68, 68); font-family: Arial;">晋中开发区信息网络发展有限公司是晋中开发区开发建设集团有限公司直属的国有企业。公司注册于2013年2月。公司主要承担综改示范区晋中开发区管理委员会及其直属企、事业单位以及开发区内广大企业客户计算机信息系统、通信信息网络系统、安全技术防范系统等规划设计、管线敷设、综合布线、设备安装、系统集成、系统改造、系统实施及系统运营、系统维护等；承担晋中开发区内智慧园区、智慧社区、智能家居的规划、设计、投资、建设、运营、管理等。同时承接政府和企业信息化建设的咨询服务、科研论证、解决方案、技术培训等。</span>
      </p>
      <p style="text-indent: 2em;">
        <span style="color: rgb(229, 102, 0); font-family: Arial;">√</span><span style="color: rgb(68, 68, 68); font-family: Arial;"> 承担晋中开发区内智慧园区、智慧社区、智能家居的规划、设计、投资、建设、运营、管理等</span>
      </p>
      <p style="text-indent: 2em;">
        <span style="color: rgb(229, 102, 0); font-family: Arial;">√</span><span style="color: rgb(68, 68, 68); font-family: Arial;"> 晋中市智慧城市开发区智慧社区建设责任单位承接政府和企业信息化建设的咨询服务、科研论证、解决方案、技术培训等</span>
      </p>
      <p style="text-indent: 2em;">
        <span style="color: rgb(229, 102, 0); font-family: Arial;">√ </span><span style="color: rgb(68, 68, 68); font-family: Arial;">晋中开发区内智慧社区、智能家居的投资、建设、运营和管理负责集团公司及其各子公司信息化项目的规划设计，硬件采供，软件开发，网络集成，系统维护及人员培训等</span>
      </p>
        </div>`
    ]
  }
}
